module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "mobile-web-app-testing.633577fe.svg";